<template>
  <div class="convention-hall page" style="width: 100%;
    url(/img/home/index_bg.png) repeat top/100% auto">
    <div style="width: 100%;position: relative;z-index: 2;background-color: rgb(244, 44, 124)"><van-nav-bar :title="$t('auth.top45')" class="nav-bar" style="height: 46px;line-height: 46px;color:#fff">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar></div>

    <div style="padding-bottom: 40px;background-color: unset;">
      <van-tabs
        v-model="active"
        title-active-color="rgb(242, 38, 120)"
        line-height="6px"
        line-width="31px"
		@change="onChange"
      >
        <van-tab
		:title="getTabTitle(item, index)"
          v-for="(item, index) in tabList"
          :key="index"
          @click="myli(item.id)"
        >
        
          <van-list
            v-model="loading"
          
            @load="onLoad"
          >
					<!-- :finished="finished"
					finished-text="没有更多了" -->
            <div class="pblBox" v-show="!isShow">
				<div style="padding: 10px;
    border: 0.5px solid rgb(153, 153, 153);
    margin: 15px;
    border-radius: 20px;width: 100%;" v-for="(v,key) in data" :key="key">
					<div style="display: flex">
						<div style="flex: 1 1 0%;">
							<img :src="v.goods_pic" style="width: 104px;height: 135px;border-radius: 10px;overflow: hidden;">
						</div>
						<div style="flex: 1 1 0%;font-size: 12px;color: rgb(0, 0, 0);">
							<div style="color: rgb(153, 153, 153)">
								{{v.addtime}}
							</div>
							<div style="font-weight: 700;line-height: 1;margin-top: 5px;">
								{{v.goods_name}}
							</div>
							<div style="display: flex;margin-top: 5px;">
								<svg data-v-35d88c84="" data-v-ec26337a="" t="1701075934189" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7823" width="12" height="12" class="icon"><path data-v-35d88c84="" data-v-ec26337a="" d="M512 74.666667c194.133333 0 352 160 352 354.133333 0 119.466667-64 236.8-168.533333 349.866667-36.266667 38.4-74.666667 72.533333-113.066667 104.533333-12.8 10.666667-25.6 21.333333-38.4 27.733333l-6.4 4.266667-8.533333 6.4c-10.666667 6.4-25.6 6.4-36.266667 0-2.133333-2.133333-4.266667-4.266667-8.533333-6.4l-12.8-8.533333c-8.533333-6.4-19.2-14.933333-29.866667-23.466667-38.4-32-76.8-66.133333-113.066667-104.533333-104.533333-110.933333-168.533333-230.4-168.533333-349.866667C160 234.666667 317.866667 74.666667 512 74.666667zM512 298.666667c-64 0-117.333333 53.333333-117.333333 117.333333S448 533.333333 512 533.333333s117.333333-53.333333 117.333333-117.333333S576 298.666667 512 298.666667z" fill="#f22678" p-id="7824"></path></svg>
								<div style="color: rgb(242, 38, 120);line-height: 1;">
									{{v.shop_name}}
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<svg data-v-35d88c84="" data-v-ec26337a="" t="1701076083955" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8905" width="12" height="12" class="icon"><path data-v-35d88c84="" data-v-ec26337a="" d="M369.792 704.32L930.304 128 1024 223.616 369.984 896l-20.288-20.864-0.128 0.128L0 516.8 96.128 423.68l273.664 280.64z" fill="#0e932e" p-id="8906"></path></svg>
								<span style="margin-left: 5px;">Wifi</span>
							</div>
						</div>
						<div style="font-size: 14px;font-weight: 700;padding: 0px 2px;width: calc(25%);">
							<div v-if="v.status==0" style="color: rgb(242, 38, 120)">{{ $t('auth.top17') }}</div>
							<div v-if="v.status==1" style="color: rgb(242, 38, 120)">{{ $t('auth.top18') }}</div>
							<div style="margin-top: 20px;color: rgb(242, 38, 120);margin-top: 7px;line-height: 1;">
								{{v.num}}
							</div>
							<div style="margin-top: 15px;line-height: 1;">
								{{ $t('auth.top9') }} {{v.commission}}
							</div>
							<div @click="tijiao(v.id)"  v-if="v.status==0" style="padding: 3px 10px;background-color: #f22678;text-align: center;color: #fff;border-radius: 20px;margin-top: 5px;">
								{{ $t('auth.top19') }}
							</div>
						</div>
					</div>
				</div>
			</div>
                    
                    
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
		
  </div>
</template>

<script>
export default {
  data() {
    return {
			addlist: [],
			isShow:false,
      banners: [{}],
      basicData: [],
      active: 0,
      tabList: [],
      data: [],
      page: 0,
			ids: 1,
			tagTypes: ['primary', 'success', 'danger', 'warning'],
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        page: 0,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },
  methods: {
		getxuanfeilist() {
      this.$http({
        method: "get",
        url: "order_list",
        data: { id: this.ids, page: this.page },
      }).then((res) => {
				this.data = res.data;this.loading = false;

				console.log(this.data,900)
      });
    },
		onLoad() { },
		toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },back() {
      return window.history.back();
    },tijiao(oid){
		this.$router.push({path:'/Bookingsubmit?id='+oid})
		},
		getTabTitle(item, index) {
			const titleKeys = ["auth.top16", "auth.top17", "auth.top18"];
			return this.$t(titleKeys[index]) || item.name;
		},
		getAddress() {
      this.$http({
        method: "get",
        url: "order_type",
      }).then((res) => {
        this.tabList = res.data;
      
      });
    },myli(id){console.log(id)
		this.ids=id;this.getxuanfeilist();console.log(id)
	},onChange(index) {
      this.ids = this.tabList[index].id;this.loading = true;this.data={};
      this.getxuanfeilist();
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;

        this.getBanner(this.basicData); //获取banner
      });
    },
    getBanner(data) {
      this.banners = data.banners;
    },
  },
  created() {
    this.getAddress();
    this.getBasicConfig();
    this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.page {
  position: absolute !important;


}
.nav-bar {
  background: unset;
  height: 100px;
}
.van-nav-bar {
  line-height: 50px;
}
::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #fff;
  font-size: 35px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
.van-sidebar {
  width: 180px;
}
// /deep/ .van-col{
// padding: 30px 0px;
// }
.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 0px;background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;
}
::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;flex: 1 0 auto;
}
::v-deep .van-tabs__line {
  background-color: unset;
}
::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}
::v-deep .van-nav-bar__title{
	color:#fff
}
::v-deep .van-row--flex {
  height: 80px;
  line-height: 80px;
}
/deep/ .van-tabs__nav{
	background: unset;
}
/deep/ .van-cell {
  padding: 30px 22px;
  font-size: 30px;
  line-height: 30px;
}
.pblBox {
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;
  flex-wrap: wrap;
}
.releaseItem {
  width: 100%;
  margin-bottom: 30px;
}
.releaseItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 320px;
}
.tags {
  display: flex;
  margin: 0px 0 4px;
  flex-wrap: wrap;
}
.tags .van-tag {
  padding: 15px 10px;
  font-size: 20px;
  margin: 0 6px 2px 0;
  border-radius: 16px;
}
.tagBox {
  font-size: 3vw;
  margin: 10px 0;
}
.di {
  display: flex;
  justify-content: space-between;
  font-size: 3vw;
  color: #666;
}

.releaseItem .imgBox .aaa {
  position: absolute;
  z-index: 9;
  height:52px;
  width:100%;
  top: 0vw;
}
.releaseItem .imgBox span {
  position: absolute;
  z-index: 9;
  height:52px;
  width:100%;
  top: 0vw;
}
.releaseItem .imgBox span i {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.releaseItem .imgBox .infoBox {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  color: #fff;
  width: 100%;
  height: 8vw;
  padding: 0 20px;
}
.releaseItem .imgBox .infoBox .wantyuebtn {
  border: 2px solid #fff;
  padding: 10px 16px;
  border-radius: 16px;
  opacity: 0.9;
  font-size: 3vw;
  margin-left: auto;
}

.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
</style>
